import React from 'react';
import { graphql } from 'gatsby';
import Layout from "../components/layout";
import SEO from '../components/seo';


const breadcrumb = [{ title: "Home", link: "/" }, { title: "Governance e Compliance" }];

const Governance = ({ data, location }) => {
  const { seo, heroDesktop, heroMobile } = data.contatti;
  return (
    <Layout location={location} hero={{ title: 'Governance e Compliance', className: 'hero--small', breadcrumb, heroDesktop, heroMobile }}>
      <SEO title={`Governance e Compliance`} seo={seo} />
      <section className="section news news--grid">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <article className="article">
                <p>
                  Una buona governance e una buona strategia sono alla base della nostra capacità di mantenere le nostre promesse, servire l'interesse pubblico e rispettare i nostri obblighi secondo i principi etici, le regole, le procedure, le politiche, i bilanci, le certificazioni e tutto ciò che riguarda la gestione e il governo della nostra organizzazione.
                </p>
                <p><strong><a href="https://www.ariadnegroup.it/images/Codice-Etico-del-Gruppo-DGS.pdf" target="_blank" rel="noopener noreferrer">CODICE ETICO</a></strong></p>
                <p>
                  Da sempre, riteniamo di fondamentale importanza il rispetto dei principi etici nella gestione del nostro business.
                </p>
                <p><strong><a href="https://report.whistleb.com/it/dgsspa" target="_blank" rel="noopener noreferrer">Ethica - Il portale per le segnalazioni</a></strong></p>
                <p>
                  Per noi integrità significa agire con responsabilità, ogni giorno. Con Ethica mettiamo a disposizione di tutte le società del gruppo DGS un canale unico, sicuro e trasparente per segnalare comportamenti illeciti o non conformi, garantendo riservatezza, protezione e ascolto a chi decide di segnalare. Uno strumento concreto per proteggere i nostri valori e costruire insieme un ambiente di lavoro etico, inclusivo e fondato sul rispetto delle regole.
                </p>
                <p><strong><a href="https://www.dgsspa.com/wp-content/uploads/2025/08/PO-10-04-Ethica-Procedura-di-segnalazione-unificata-1.pdf" target="_blank" rel="noopener noreferrer">Ethica - La procedura di segnalazione unificata</a></strong></p>
                <p>
                  Il nostro sistema di segnalazione, conforme al D.lgs. 24/2023, al Modello 231, alla SA8000, alla UNI PdR 125 e ad altre normative applicabili, definisce in modo chiaro oggetto, contenuti, destinatari e modalità di invio delle segnalazioni.
                </p>
                <p>
                  La procedura garantisce piena tutela al segnalante e rappresenta uno strumento essenziale per prevenire, rilevare e gestire tempestivamente condotte illecite o situazioni di non conformità, a tutela dell’integrità dell’intera organizzazione.
                </p>
              </article>
            </div>
          </div>

        </div>
      </section>
    </Layout>
  );
}

export default Governance;
export const query = graphql`{
  contatti: contentfulPaginaGenerica(contentful_id: { eq: "4CTw0M5UUuR5Sg3pbqN8Pf" }) {
    seo {
      ...SeoFragment
    }
    heroDesktop: hero {
      ...HeroContentfulDesktop
    }
    heroMobile: hero {
      ...HeroContentfulMobile
    }
  }
}`;


